<ng-select
	[items]="items"
	[bindLabel]="bindLabel"
	[bindValue]="bindValue"
	[searchable]="searchable"
	[placeholder]="placeholder"
	[clearable]="clearable"
	[loading]="items == undefined"
	[formControl]="formControl"
	(change)="onSelect($event)"
	(focus)="focus.emit()"
	[readonly]="readonly"
	[multiple]="multiple"
	[class.ng-select-dark]="true"
	[class.is-invalid]="invalid || (formControl?.invalid && formControl?.touched)"
	[appendTo]="appendTo"
	(clear)="onClear($event)"
	class="fs-13 min-width"
>
</ng-select>

@if ((formControl?.invalid && formControl?.touched) || invalid) {
	@if (formControl?.errors?.["required"]) {
		<div class="invalid-feedback d-block">Ce champ est obligatoire.</div>
	} @else {
		<div class="invalid-feedback d-block">Ce champ est invalide.</div>
	}
}
